export default "__VITE_ASSET__dc412353__"